import { UnauthorizedAccess } from "@/components/unauthorized-access";
import useAuthStore from "@/store/useAuthStore";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/admin/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { isLoggedIn, user } = useAuthStore();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate({ to: "/auth/login" });
      return;
    }

    setLoading(false);
  }, [isLoggedIn, navigate]);

  if (user?.user_type != "91ac9e") {
    return <UnauthorizedAccess />;
  }

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="animate-spin h-10 w-10 border-4 border-blue-500 rounded-full border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  );
}
